import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CGV_TEXT, CGV_VERSION } from "@/content/cgv";
import { useSeoMeta } from "@/lib/useSeoMeta";

function classify(line) {
  if (/^CONDITIONS GÉNÉRALES/.test(line)) return "h1";
  if (/^(Préambule|Sommaire)$/.test(line)) return "h2";
  if (/^Article \d+\./.test(line) || /^Annexe \d+\./.test(line)) return "h2";
  if (/^(A\d+\.\d+ |\d+\.\d+ )/.test(line)) return "h3";
  return "p";
}

export default function CGVPage() {
  // Page contractuelle : utile aux clients, sans intérêt pour l'index Google.
  useSeoMeta({
    title: "CGV & CGU — EmpCo",
    description: "Conditions générales de vente et d'utilisation d'EmpCo SAS.",
    canonical: "https://empco-compliance.eu/cgv",
    robots: "noindex, follow",
  });
  const lines = CGV_TEXT.split("\n");
  return (
    <div className="App min-h-screen flex flex-col bg-white" data-testid="cgv-page">
      <Header variant="public" />
      <main className="flex-1">
        <div className="max-w-[860px] mx-auto px-6 md:px-10 py-16 md:py-24">
          <div className="mb-10 pb-6 border-b border-border">
            <p className="eyebrow mb-2">Document contractuel</p>
            <h1 className="text-3xl md:text-4xl font-serif tracking-tight" data-testid="cgv-title">Conditions Générales de Vente et d'Utilisation</h1>
            <p className="font-mono text-xs text-muted-foreground mt-3">Version {CGV_VERSION}</p>
          </div>
          <article className="cgv-prose space-y-3">
            {lines.map((raw, i) => {
              const line = raw.trim();
              if (!line) return null;
              const kind = classify(line);
              if (kind === "h1") return <h2 key={i} className="sr-only">{line}</h2>;
              if (kind === "h2") return <h2 key={i} className="text-xl md:text-2xl font-serif tracking-tight text-primary mt-10 mb-1">{line}</h2>;
              if (kind === "h3") return <h3 key={i} className="text-base font-semibold text-foreground mt-5">{line}</h3>;
              return <p key={i} className="text-sm text-foreground/80 leading-relaxed">{line}</p>;
            })}
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}
